<template>
	<div class="chargeManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">社区设备管理</div>
		</div>
		<div class="mainBot disBetween">
			<div class="contentLeft">
				<!-- 社区板块 -->
				<communityManagement ref="communityManagement" :areaList="areaList" :typeList="typeList"
					@moduleOne="moduleOne" @moduleTwo="moduleTwo"></communityManagement>
			</div>
			<div class="contentRight">
				<!-- <div class="contentTop">
					充电站板块
					<stationManagement ref="stationManagement" :areaList="areaList" @moduleZero="moduleZero" @moduleOne="moduleOne" @moduleTwo="moduleTwo" @moduleFour="moduleFour"></stationManagement>
				</div> -->
				<div class="contentBot">
					<!-- 设备版块 -->
					<equipmentManagement ref="equipmentManagement" @moduleZero="moduleZero" @moduleOne="moduleOne"   @moduleThree="moduleThree" @goUrl="goUrl"></equipmentManagement>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import communityManagement from "./communityManagement/communityManagement.vue"
	import stationManagement from "./stationManagement/stationManagement.vue"
	import equipmentManagement from "./equipmentManagement/equipmentManagement.vue"
	export default {
		name: "chargeManage",
		components: {
			communityManagement,
			stationManagement,
			equipmentManagement
		},
		data() {
			return {
				// 省市区数据
				areaList: [],
				// 社区类型
				typeList: []
			}
		},
		mounted() {
			this.getData()
			this.$nextTick(() => {
				// 获取社区
				this.moduleZero({n:1,k:1})
			})
		},
		methods: {
			getData() {
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
				if (!(localStorage.getItem("typeList"))) {
					this.getTypeList()
				} else {
					this.$set(this, "typeList", JSON.parse(localStorage.getItem("typeList")))
				}
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			// 社区类型
			getTypeList() {
				this.$api.listAllCommunityType().then((res) => {
					
					if (res.returnCode == 200) {
						this.$set(this, "typeList", res.obj)
						localStorage.setItem('typeList', JSON.stringify(res.obj))
					}
				})
			},
			moduleZero(obj){
				this.$refs.communityManagement.getData(obj)
				this.$refs.communityManagement.getequipmenToken()
				this.$refs.communityManagement.getequipmentStatus()
				
			},
			// 获取充电站
			moduleOne(obj) {
				
				// this.$refs.stationManagement.getData(obj)
			},
			// 获取设备
			moduleTwo(obj) {
				console.log(obj,111111);
				this.$refs.equipmentManagement.getData(obj)
			},
			// 
			moduleThree(obj) {
				
				// this.$refs.stationManagement.openDia(5)
			},
			moduleFour(id){
				this.$refs.equipmentManagement.setStationList(id)
			},
			goUrl(obj,str){
				this.$router.push({path: str,query:obj});
				this.$emit("setPath",str)
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargeManage.scss";
</style>
